import { useEffect, useState } from "react";
import { EDITOR_VIEW_NAME, STEP_POPPER } from "../../core/constants";
import { store } from "../../core/state";
import { TaskAreaSwitch } from "./TaskAreaSwitch";
import { TaskAreaCard } from "./TaskAreaCard";


export function TaskArea() {
  const [showTaskState, setShowTaskState] = useState(false);
  //const [taskAreaData] = store.useState(TASK_AREA_STATE);
  const [editorState] = store.useState(EDITOR_VIEW_NAME);
  const [stepPopper] = store.useState(STEP_POPPER);
  
  useEffect(() => {
    if (stepPopper.show && stepPopper.dismissed) {
      setShowTaskState(true);
    }
  }, [stepPopper]);

  const openArea = () => {
    setShowTaskState(true);
  }

  const closeArea = () => {
    setShowTaskState(false);
  }  

  const openButton = <TaskAreaSwitch switch={openArea} />;  
  const taskCard = <TaskAreaCard closeArea={closeArea} taskOpened={editorState.cfg?.editorFeatures?.taskAccordionOpenedOnDefault} />;
  
  const taskOpened = editorState.cfg?.editorFeatures?.openTaskOnDefault;
  return (
    <span>
      { (!showTaskState && !taskOpened) && openButton }
      { (showTaskState || taskOpened) && taskCard }
    </span>
  );
}
